/*
 * Jira Ticket:
 * Created Date: Wed, 13th May 2020, 09:58:07 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { SelectInput } from 'react-admin';

// NOTE: This input is to be used in Organisation Reference type fields where we need to display the
// principal organisation (the org you are currently viewing) and also it's contractors
// so we prepend the principal organisation, unless it is already present in the choices list

const CombinedOrgSelectInput = props => {
  let { choices, organisationId, organisationName, ...rest } = props;
  if (!choices.find(choice => choice.id === organisationId)) {
    choices.unshift({
      id: organisationId,
      name: organisationName,
    });
  }
  return choices.length > 0 ? (
    <SelectInput choices={choices} optionText="name" {...rest} />
  ) : null;
};

export default CombinedOrgSelectInput;
